import { Dialog } from '../dialog/dialog';
import { useModalStore } from './store';

export const Modals = () => {
  const { modal, setModal } = useModalStore();

  const handleClose = () => {
    setModal({
      ...modal,
      key: null,
    });
  };

  return (
    <Dialog
      handleClose={handleClose}
      open={!!modal?.key}
      scrollBehavior="inside"
      content={modal.content}
    />
  );
};
